import {
    CANCEL_SUBSCRIPTION_FAIL,
    CANCEL_SUBSCRIPTION_REQUEST,
    CANCEL_SUBSCRIPTION_SUCCESS,
    GET_SUBSCRIPTION_FAIL,
    GET_SUBSCRIPTION_REQUEST,
    GET_SUBSCRIPTION_SUCCESS,
    START_TRIAL_FAIL,
    START_TRIAL_REQUEST,
    START_TRIAL_SUCCESS,
} from "../types";

export const cancelSubscriptionRequest = (history: any) => {
    return {
        type: CANCEL_SUBSCRIPTION_REQUEST,
        payload: history,
    };
};

export const cancelSubscriptionSuccess = () => {
    return {
        type: CANCEL_SUBSCRIPTION_SUCCESS,
    };
};

export const cancelSubscriptionFail = (error: any) => {
    return {
        type: CANCEL_SUBSCRIPTION_FAIL,
        payload: {
            error,
        },
    };
};

export const getSubscriptionRequest = (id: number) => {
    return {
        type: GET_SUBSCRIPTION_REQUEST,
        payload: {
            id,
        },
    };
};

export const getSubscriptionSuccess = (data: any) => {
    return {
        type: GET_SUBSCRIPTION_SUCCESS,
        payload: {
            data,
        },
    };
};

export const getSubscriptionFail = (error: any) => {
    return {
        type: GET_SUBSCRIPTION_FAIL,
        payload: {
            error,
        },
    };
};

export const startTrialRequest = (history: any, customerTrialEmailId?: number, region?: string) => {
    return {
        type: START_TRIAL_REQUEST,
        payload: { history, customerTrialEmailId, region },
    };
};

export const startTrialSuccess = (data: any) => {
    return {
        type: START_TRIAL_SUCCESS,
        payload: { data },
    };
};

export const startTrialFail = (error: any) => {
    return {
        type: START_TRIAL_FAIL,
        payload: { error },
    };
};
